module.exports = __webpack_public_path__ + "img/product-card-hero-desktop.45ffc85.webp";